// organization.actions.ts
import { createAction, props } from "@ngrx/store";
import { Organization } from "../../models/organization-field";

// Load actions
const loadOrganization = createAction("[Organization] Load Organization");

const loadOrganizationSuccess = createAction(
  "[Organization] Load Organization Success",
  props<{ organizationList: Organization[] }>()
);

const loadOrganizationFailure = createAction(
  "[Organization] Load Organization Failure",
  props<{ error: any }>()
);

// Create actions
const createOrganization = createAction(
  "[Organization] Create Client",
  props<{ organization: Organization }>()
);

const createOrganizationSuccess = createAction(
  "[Organization] Create Clint Success",
  props<{ organization: Organization }>()
);

const createOrganizationFailure = createAction(
  "[Organization] Create Client Failure",
  props<{ error: any }>()
);

// Edit actions
const editOrganization = createAction(
  "[Organization] Edit Organization",
  props<{ organization: Organization }>()
);

const editOrganizationSuccess = createAction(
  "[Organization] Edit Organization Success",
  props<{ organization: Organization }>()
);

// Delete actions
const deleteOrganization = createAction(
  "[Organization] Delete Organization",
  props<{ organizationId: string }>()
);

const deleteOrganizationSuccess = createAction(
  "[Organization] Delete Organization Success",
  props<{ organizationId: string }>()
);

export const OrganizationActions = {
  loadOrganization,
  loadOrganizationSuccess,
  loadOrganizationFailure,
  createOrganization,
  createOrganizationSuccess,
  createOrganizationFailure,
  editOrganization,
  editOrganizationSuccess,
  deleteOrganization,
  deleteOrganizationSuccess
};
